/* Original-photo navigation and a read-only quick view. Pricing stays server rendered. */
(() => {
  'use strict';
  const initialized = new WeakSet();
  const state = new WeakMap();
  const preview = document.getElementById('XyraProductPreview');
  let previewImages = [], previewIndex = 0, returnFocus = null;
  const safeImage = src => {
    try { const u = new URL(src, location.href); return /^https?:$/.test(u.protocol) ? u.href : ''; }
    catch (_) { return ''; }
  };
  const imagesFor = card => {
    try {
      const images = JSON.parse(card.querySelector('[data-card-images]')?.textContent || '[]');
      return Array.isArray(images) ? images.filter(x => x && typeof x.src === 'string' && safeImage(x.src)).slice(0,100) : [];
    } catch (_) { return []; }
  };
  function setImage(node, data, thumbnail = false) {
    if (!node || !data) return;
    const src = safeImage(thumbnail ? data.thumb || data.src : data.src);
    if (!src) return;
    node.removeAttribute('srcset');
    node.src = src;
    node.alt = data.alt || '';
    node.draggable = false;
  }
  // Threshold plus directional lock leaves vertical page scrolling and pinch zoom native.
  function swipe(target, move) {
    let start = null, suppressClickUntil = 0;
    target.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('button,video,iframe,model-viewer')) { start = null; return; }
      start = {x:event.clientX, y:event.clientY, id:event.pointerId};
    }, {passive:true});
    target.addEventListener('pointerup', event => {
      if (!start || event.pointerId !== start.id) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) >= 38 && Math.abs(dx) > Math.abs(dy)*1.4) {
        suppressClickUntil = performance.now() + 420;
        move(dx < 0 ? 1 : -1);
      }
    }, {passive:true});
    target.addEventListener('pointercancel', () => { start = null; }, {passive:true});
    target.addEventListener('dragstart', event => event.preventDefault());
    target.addEventListener('click', event => {
      if (performance.now() < suppressClickUntil && !event.target.closest('button')) {
        event.preventDefault(); event.stopPropagation();
      }
    }, true);
  }
  function initGallery(card) {
    if (initialized.has(card)) return;
    initialized.add(card);
    const stage = card.querySelector('[data-card-gallery]');
    if (!stage) return;
    const images = imagesFor(card);
    const image = card.querySelector('[data-card-image]');
    const index = {images, current:0}; state.set(card,index);
    function show(change) {
      if (images.length < 2) return;
      index.current = (index.current + change + images.length) % images.length;
      setImage(image,images[index.current]);
      const text = `${index.current+1} / ${images.length}`;
      const position = card.querySelector('[data-card-position]'); if (position) position.textContent = text;
      const status = card.querySelector('[data-card-status]'); if (status) status.textContent = text;
    }
    stage.addEventListener('click',event=> {
      if (event.target.closest('[data-card-prev]')) { event.preventDefault(); show(-1); }
      if (event.target.closest('[data-card-next]')) { event.preventDefault(); show(1); }
    });
    stage.addEventListener('keydown',event=> {
      if (event.key==='ArrowLeft' || event.key==='ArrowRight') {
        if (event.target.closest('[data-wishlist-save]')) return;
        event.preventDefault(); show(event.key==='ArrowRight'?1:-1);
      }
    });
    swipe(stage,show);
  }
  function showPreview(change=0, absolute=null) {
    if (!preview || !previewImages.length) return;
    previewIndex = absolute===null ? (previewIndex+change+previewImages.length)%previewImages.length : absolute;
    setImage(preview.querySelector('[data-preview-image]'),previewImages[previewIndex]);
    preview.querySelector('[data-preview-position]').textContent = `${previewIndex+1} / ${previewImages.length}`;
    preview.querySelectorAll('[data-preview-thumb]').forEach((button,i)=>button.setAttribute('aria-current',String(i===previewIndex)));
    preview.querySelector('[data-preview-prev]').hidden = previewImages.length<2;
    preview.querySelector('[data-preview-next]').hidden = previewImages.length<2;
  }
  function openPreview(card,opener) {
    if (!preview || typeof preview.showModal!=='function') { location.assign(card.dataset.cardUrl); return; }
    previewImages = state.get(card)?.images || imagesFor(card);
    if (!previewImages.length) return;
    previewIndex = state.get(card)?.current || 0;
    returnFocus = opener;
    preview.querySelector('[data-preview-title]').textContent=card.dataset.cardTitle||'';
    preview.querySelector('[data-preview-vendor]').textContent=card.dataset.cardVendor||'';
    const price = card.querySelector('.price');
    preview.querySelector('[data-preview-price]').replaceChildren(...(price ? [price.cloneNode(true)] : []));
    preview.querySelector('[data-preview-link]').href = card.dataset.cardUrl;
    preview.querySelector('[data-preview-availability]').textContent = card.dataset.cardAvailable==='false' ? preview.dataset.unavailable : '';
    const saved = card.querySelector('[data-wishlist-save]')?.cloneNode(true);
    if(saved&&!saved.querySelector('span')){const label=document.createElement('span');label.textContent=saved.getAttribute('aria-pressed')==='true'?saved.dataset.removeLabel:saved.dataset.saveLabel;saved.append(label);}
    preview.querySelector('[data-preview-wishlist]').replaceChildren(...(saved?[saved]:[]));
    const thumbs = preview.querySelector('[data-preview-thumbs]'); thumbs.replaceChildren();
    previewImages.forEach((data,i)=> {
      const button=document.createElement('button'); button.type='button'; button.dataset.previewThumb=String(i);
      button.setAttribute('aria-label',`${preview.dataset.imageLabel} ${i+1}`);
      const image=document.createElement('img'); image.width=60;image.height=75;image.loading='lazy';
      setImage(image,data,true); image.alt=''; button.append(image); thumbs.append(button);
    });
    showPreview(0,previewIndex);
    if(!preview.open) preview.showModal();
    document.body.classList.add('modal-open');
    preview.querySelector('[data-close-dialog]').focus({preventScroll:true});
  }
  document.addEventListener('click',event=> {
    const opener=event.target.closest('[data-open-preview]');
    if (opener) { event.preventDefault();const card=opener.closest('[data-product-card]');if(card)openPreview(card,opener); }
  });
  preview?.addEventListener('click',event=> {
    if (event.target.closest('[data-preview-prev]')) showPreview(-1);
    if (event.target.closest('[data-preview-next]')) showPreview(1);
    const thumb=event.target.closest('[data-preview-thumb]');if(thumb)showPreview(0,Number(thumb.dataset.previewThumb));
  });
  preview?.addEventListener('keydown',event=> {
    if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showPreview(event.key==='ArrowRight'?1:-1);}
  });
  preview?.addEventListener('close',()=> {
    document.body.classList.toggle('modal-open',Boolean(document.querySelector('dialog[open]')));
    if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});
  });
  if(preview)swipe(preview.querySelector('[data-preview-stage]'),showPreview);
  function init(root=document){root.querySelectorAll('[data-product-card]').forEach(initGallery);}
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('xyra:catalog:updated',()=>init());
  init();
})();
